
import React, { useState } from 'react';
import {
  Container,
  Row,
  Col,
  Nav,
  Card,
  Button,
} from 'react-bootstrap';

import {
  People,
  Cart3,
  BoxSeam,
  Speedometer2,
  ChevronRight,
} from 'react-bootstrap-icons';

import CustomersPage from './CustomersPage';
import AdminOrdersPage from './AdminOrdersPage';
import ProductList from './ProductList';

function AdminMainPage() {
  const [activeTab, setActiveTab] = useState('customers');

  const menuItems = [
    {
      key: 'customers',
      label: 'Customers',
      description: 'Manage customer accounts and information',
      icon: People,
    },
    {
      key: 'orders',
      label: 'Orders',
      description: 'View and manage customer orders',
      icon: Cart3,
    },
    {
      key: 'products',
      label: 'Products',
      description: 'Manage your product catalogue',
      icon: BoxSeam,
    },
  ];

  const activeItem =
    menuItems.find((item) => item.key === activeTab) ||
    menuItems[0];

  const renderActivePage = () => {
    switch (activeTab) {
      case 'customers':
        return <CustomersPage />;

      case 'orders':
        return <AdminOrdersPage />;

      case 'products':
        return <ProductList />;

      default:
        return <CustomersPage />;
    }
  };

  return (
    <>
      <style>
        {`
          .admin-dashboard {
            min-height: 100vh;
            background: #f6f8fb;
          }

          .admin-sidebar {
            background: #ffffff;
            border: 1px solid #e8ebf0;
            border-radius: 18px;
            padding: 18px;
            position: sticky;
            top: 20px;
          }

          .admin-brand {
            display: flex;
            align-items: center;
            gap: 12px;
            padding: 8px 8px 20px;
            margin-bottom: 10px;
            border-bottom: 1px solid #eef0f3;
          }

          .admin-brand-icon {
            width: 42px;
            height: 42px;
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #111827;
            color: #ffffff;
            flex-shrink: 0;
          }

          .admin-brand-title {
            font-size: 17px;
            font-weight: 700;
            color: #111827;
            line-height: 1.2;
          }

          .admin-brand-subtitle {
            font-size: 12px;
            color: #8a94a6;
            margin-top: 3px;
          }

          .admin-nav-link {
            display: flex !important;
            align-items: center;
            gap: 12px;
            width: 100%;
            padding: 12px 13px !important;
            margin-bottom: 6px;
            border-radius: 12px !important;
            color: #596579 !important;
            background: transparent !important;
            transition:
              background 0.2s ease,
              color 0.2s ease,
              transform 0.2s ease;
            text-decoration: none;
          }

          .admin-nav-link:hover {
            background: #f4f6f9 !important;
            color: #111827 !important;
            transform: translateX(2px);
          }

          .admin-nav-link.active {
            background: #111827 !important;
            color: #ffffff !important;
          }

          .admin-nav-link.active .admin-nav-icon {
            background: rgba(255,255,255,0.12);
            color: #ffffff;
          }

          .admin-nav-icon {
            width: 36px;
            height: 36px;
            border-radius: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #f4f6f9;
            color: #596579;
            flex-shrink: 0;
          }

          .admin-nav-content {
            flex: 1;
            min-width: 0;
          }

          .admin-nav-title {
            display: block;
            font-size: 14px;
            font-weight: 600;
          }

          .admin-nav-description {
            display: block;
            font-size: 11px;
            margin-top: 2px;
            opacity: 0.75;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .admin-nav-arrow {
            opacity: 0;
            transition: opacity 0.2s ease;
          }

          .admin-nav-link.active .admin-nav-arrow,
          .admin-nav-link:hover .admin-nav-arrow {
            opacity: 1;
          }

          .admin-main {
            min-width: 0;
          }

          .admin-header {
            background: #ffffff;
            border: 1px solid #e8ebf0;
            border-radius: 18px;
            padding: 22px 24px;
            margin-bottom: 18px;
          }

          .admin-header-top {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 20px;
          }

          .admin-header-title {
            display: flex;
            align-items: center;
            gap: 12px;
            margin: 0;
            font-size: 24px;
            font-weight: 750;
            color: #111827;
          }

          .admin-header-icon {
            width: 44px;
            height: 44px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 12px;
            background: #f1f3f6;
            color: #111827;
          }

          .admin-header-description {
            margin: 7px 0 0 56px;
            color: #7b8494;
            font-size: 14px;
          }

          .admin-status {
            display: inline-flex;
            align-items: center;
            gap: 7px;
            padding: 7px 11px;
            border-radius: 999px;
            background: #f0fdf4;
            color: #15803d;
            font-size: 12px;
            font-weight: 600;
            white-space: nowrap;
          }

          .admin-status-dot {
            width: 7px;
            height: 7px;
            border-radius: 50%;
            background: #22c55e;
          }

          .admin-content {
            background: #ffffff;
            border: 1px solid #e8ebf0;
            border-radius: 18px;
            padding: 24px;
            min-height: 500px;
          }

          .admin-mobile-nav {
            display: none;
            overflow-x: auto;
            padding-bottom: 4px;
            margin-bottom: 18px;
          }

          .admin-mobile-nav::-webkit-scrollbar {
            height: 4px;
          }

          .admin-mobile-link {
            flex: 0 0 auto;
            display: flex;
            align-items: center;
            gap: 7px;
            border: 1px solid #e3e7ed;
            background: #ffffff;
            color: #596579;
            border-radius: 10px;
            padding: 9px 13px;
            font-size: 13px;
            font-weight: 600;
            white-space: nowrap;
          }

          .admin-mobile-link.active {
            background: #111827;
            border-color: #111827;
            color: #ffffff;
          }

          @media (max-width: 991.98px) {
            .admin-sidebar {
              display: none;
            }

            .admin-mobile-nav {
              display: flex;
              gap: 8px;
            }

            .admin-header-description {
              margin-left: 0;
            }
          }

          @media (max-width: 575.98px) {
            .admin-dashboard {
              background: #f6f8fb;
            }

            .admin-header {
              padding: 18px;
              border-radius: 14px;
            }

            .admin-header-top {
              align-items: flex-start;
            }

            .admin-header-title {
              font-size: 20px;
            }

            .admin-header-icon {
              width: 38px;
              height: 38px;
            }

            .admin-status {
              font-size: 11px;
            }

            .admin-content {
              padding: 16px;
              border-radius: 14px;
            }
          }
        `}
      </style>

      <div className="admin-dashboard">
        <Container fluid className="py-4 px-3 px-lg-4">
          <Row className="g-4">

            {/* =====================================================
                LEFT SIDEBAR
            ===================================================== */}
            <Col lg={3} xl={2}>
              <aside className="admin-sidebar">

                <div className="admin-brand">
                  <div className="admin-brand-icon">
                    <Speedometer2 size={21} />
                  </div>

                  <div>
                    <div className="admin-brand-title">
                      Admin Panel
                    </div>

                    <div className="admin-brand-subtitle">
                      Store management
                    </div>
                  </div>
                </div>

                <Nav className="flex-column">

                  {menuItems.map((item) => {
                    const Icon = item.icon;
                    const isActive = activeTab === item.key;

                    return (
                      <Nav.Link
                        key={item.key}
                        eventKey={item.key}
                        active={isActive}
                        className={`admin-nav-link ${
                          isActive ? 'active' : ''
                        }`}
                        onClick={() => setActiveTab(item.key)}
                        aria-current={
                          isActive ? 'page' : undefined
                        }
                      >
                        <div className="admin-nav-icon">
                          <Icon size={17} />
                        </div>

                        <div className="admin-nav-content">
                          <span className="admin-nav-title">
                            {item.label}
                          </span>

                          <span className="admin-nav-description">
                            {item.description}
                          </span>
                        </div>

                        <ChevronRight
                          size={15}
                          className="admin-nav-arrow"
                        />
                      </Nav.Link>
                    );
                  })}

                </Nav>
              </aside>
            </Col>

            {/* =====================================================
                MAIN CONTENT
            ===================================================== */}
            <Col lg={9} xl={10}>
              <main className="admin-main">

                {/* MOBILE NAVIGATION */}
                <div className="admin-mobile-nav">
                  {menuItems.map((item) => {
                    const Icon = item.icon;
                    const isActive = activeTab === item.key;

                    return (
                      <button
                        key={item.key}
                        type="button"
                        className={`admin-mobile-link ${
                          isActive ? 'active' : ''
                        }`}
                        onClick={() => setActiveTab(item.key)}
                        aria-current={
                          isActive ? 'page' : undefined
                        }
                      >
                        <Icon size={15} />
                        {item.label}
                      </button>
                    );
                  })}
                </div>

                {/* PAGE HEADER */}
                <div className="admin-header">
                  <div className="admin-header-top">

                    <div>
                      <h1 className="admin-header-title">
                        <span className="admin-header-icon">
                          {React.createElement(
                            activeItem.icon,
                            { size: 21 }
                          )}
                        </span>

                        {activeItem.label}
                      </h1>

                      <p className="admin-header-description">
                        {activeItem.description}
                      </p>
                    </div>

                    <div className="admin-status">
                      <span className="admin-status-dot" />
                      Admin
                    </div>

                  </div>
                </div>

                {/* PAGE CONTENT */}
                <div className="admin-content">
                  {renderActivePage()}
                </div>

              </main>
            </Col>

          </Row>
        </Container>
      </div>
    </>
  );
}

export default AdminMainPage;

